import { useCallback } from 'react'

import { useDialog } from '@/shared/components/Dialog/DialogContext'
import { InsufficientCreditsDialog } from '@/shared/components/Dialog/InsufficientCreditsDialog'

export function useInsufficientCreditsDialog() {
  const { openDialog } = useDialog()

  const showInsufficientCreditsDialog = useCallback(() => {
    openDialog(InsufficientCreditsDialog, {})
  }, [openDialog])

  return { showInsufficientCreditsDialog }
}
